import React from "react";
import "./Qiymat-sarlavha.css";

function QiymatSarlavha({ mavzuSoni, activeTopicName }) {
  return (
    <div className="qiymat-sarlavha-quti">
      <div className="qiymat-sarlavha-mavzu">
        <p>{activeTopicName}</p>
      </div>
      <div className="qidiruv-input">
        <div className="qiymat-sarlavha-soni">
          <p>{mavzuSoni ? `Darslar soni: ${mavzuSoni} ta` : ""}</p>
        </div>
      </div>
    </div>
  );
}
export default QiymatSarlavha;
